import startCase from 'lodash/startCase'
import {mergeConfig} from '../configStore'
import type {GroupProps, GroupReturn} from '../types'

export const define = (name: string, props?: GroupProps, mergeProps?: GroupProps): GroupReturn => {
  const defaultProps = {
    title: startCase(name),
    default: false,
  }

  return {name, ...mergeConfig('group', props, mergeProps, defaultProps)}
}
